










































import Vue from 'vue';
import Component from 'vue-class-component';
import { deviceRouteName } from '../app';

@Component({
  methods: {
    deviceRouteName,
  },
  props: {
    collection: {
      required: true,
    },
    name: {
      required: true,
    },
    createRoute: {
      required: false,
    },
    listRoute: {
      required: true,
    },
  },
})
export default class DashboardCollectionTile extends Vue {}
